const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const STORAGE_KEY = "admin_auth_session";
const API_BASE = `${ENV_API_BASE_URL}/api`;

export const getAdminSession = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const isAdminAuthenticated = () => {
  const session = getAdminSession();
  if (!session?.token || !session?.exp) return false;
  return session.exp * 1000 > Date.now();
};

export const setAdminSession = (session) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearAdminSession = () => {
  window.localStorage.removeItem(STORAGE_KEY);
};

export const verifyAdminSession = async () => {
  const session = getAdminSession();
  if (!session?.token) return null;

  const res = await fetch(`${API_BASE}/auth/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.token}`,
    },
  });

  if (!res.ok) {
    clearAdminSession();
    return null;
  }

  const json = await res.json();
  if (!json?.success) {
    clearAdminSession();
    return null;
  }

  const nextSession = {
    ...session,
    ...json.data,
    token: session.token,
  };
  setAdminSession(nextSession);
  return nextSession;
};
